import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import { TextField, Button, DialogActions, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import { config as url } from "../../../common/config";
import AlertNotistack from "../../../components/molecules/AlertNotistack";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

const useStyles = makeStyles((theme) => ({
	textField: {
		marginBottom: 16,
	},
	form: {
		border: "1px solid rgba(0, 0, 0, 0.23)",
		borderRadius: 4,
		backgroundColor: "white",
		boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
		padding: "18.5px 14px",
		width: "50%",
		height: "50%",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
		},
	},
	formControl: {
		border: "1px solid rgba(0, 0, 0, 0.23)",
		borderRadius: 4,
		padding: "18.5px 14px",
		width: "100%",
	},
}));

const FormSLA = () => {
	const BaseUrl = `${url.optionMaster}`;
	const { enqueueSnackbar } = useSnackbar();
	const classes = useStyles();
	const fetchData = useContext(FetchDataContext);
	const { getFetchData, updateData } = fetchData;

	const [settingState, setSettingState] = useState({
		sla: "",
		percent: "",
		sendtime: "",
	});

	const { sla, percent, sendtime } = settingState;
	const { handleSubmit, errors, register, clearErrors } = useForm();

	const handleChangeSetting = (event) => {
		setSettingState({
			...settingState,
			[event.target.name]: event.target.value,
		});
	};

	const setupSLA = async () => {
		try {
			let result = await getFetchData({ url: `${BaseUrl}/sla_time` });
			if (result) {
				setSettingState({
					sla: result?.data?.sla,
					percent: result?.data?.percent,
					sendtime: result?.data?.sendtime,
				});
			}
			return result;
		} catch (error) {
			throw error;
		}
	};

	useEffect(() => {
		setupSLA();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleOpenCloseFormAdd = () => {
		return true;
	};

	const swalSuccess = (data) => {
		Swal.fire({
			type: "success",
			title: "Anda yakin ingin mengubahnya?",
			icon: "warning",
			showCancelButton: true,
			cancelButtonText: "Tidak",
		}).then((result) => {
			if (result.value) {
				onHandleSubmit();
			}
		});
	};

	const onHandleSubmit = async () => {
		try {
			const data = {
				deadline: settingState.percent,
			};
			const res = await updateData(
				`${url.login}/deadline`,
				data,
				handleOpenCloseFormAdd
			);
			if (res.status === "success") {
				setupSLA();
				clearErrors();
			}
		} catch (err) {
			enqueueSnackbar(err.message, AlertNotistack(err.status));
			throw err;
		}
	};

	return (
		<form
			autoComplete="off"
			className={classes.form}
			onSubmit={handleSubmit(swalSuccess)}
		>
			<TextField
				// required
				fullWidth
				variant="outlined"
				id="sla"
				name="sla"
				label="SLA Minimum"
				className={classes.textField}
				type="number"
				value={sla}
				disabled
				onChange={handleChangeSetting}
			/>
			<TextField
				// required
				fullWidth
				variant="outlined"
				id="percent"
				name="percent"
				label="Percent %"
				type="number"
				className={classes.textField}
				value={percent}
				error={errors.percent}
				onChange={handleChangeSetting}
				inputRef={register({
					required: {
						value: true,
						message: "Percent tidak boleh kosong",
					},
					max: {
						value: 90,
						message: "Maximal 90 %",
					},
					min: {
						value: 1,
						message: "Minimal 1 %",
					},
				})}
				InputLabelProps={{ shrink: true }}
				helperText={errors.percent && errors.percent.message}
			/>
			<TextField
				// required
				fullWidth
				variant="outlined"
				type="number"
				id="sendtime"
				name="sendtime"
				label="Send Time"
				disabled
				className={classes.textField}
				value={sendtime}
				onChange={handleChangeSetting}
			/>
			<DialogActions
				style={{
					width: "100%",
				}}
			>
				<Grid
					className="form-group"
					style={{
						display: "flex",
						justifyContent: "end",
					}}
				>
					<Button
						type="submit"
						// disabled={state.loading}
						variant="contained"
						color="primary"
					>
						Submit &#10148;
					</Button>
				</Grid>
			</DialogActions>
		</form>
	);
};

FormSLA.propTypes = {
	onSetSettingData: PropTypes.func.isRequired,
	data: PropTypes.objectOf.isRequired,
};

export default FormSLA;
